import {createSlice} from '@reduxjs/toolkit';
import {
    deviceRegisterAPI,
    inquiryStartAPI,
    inquirySaveAPI,
    inquirySubmitAPI,
    inquiryGetAPI,
    inquiryGetMediaAPI,
    inquiryCreateMediaAPI,
    inquiryDeleteMediaAPI
} from '../api/registerAPI';

const initialState = {
    start: null,
    error: null,
    medias: null,
    mediasError: null
};

export const registerSlice = createSlice({
    name: 'register',
    initialState,
    reducers: {
        startError(state, action) {
            state.error = action.payload
        },
        startSuccess(state, action) {
            state.data = action.payload
        },
        getMediaSuccess(state, action) {
            state.medias = action.payload
        },
        getMediaError(state, action) {
            state.mediasError = action.payload
        },
    },
    extraReducers: (builder) => {
    },
});
export const {startError, startSuccess, getMediaSuccess, getMediaError} = registerSlice.actions;

export const deviceRegister = (data, callback) => async (dispatch, getState) => {
    const response = await deviceRegisterAPI(data)
    if (callback) callback(response)
    return response;
};
export const inquiryStart = (orgId, callback) => async (dispatch, getState) => {
    const response = await inquiryStartAPI(orgId)

    if (response) {
        dispatch(startSuccess(response))
    }
    if (callback) callback(response)
    return response;
};

export const inquirySave = (orgId, id, data, isReview, callback) => async (dispatch, getState) => {
    try {
        console.log(isReview)
        const response = await inquirySaveAPI(orgId, id, data, isReview)
        if (response) {
            dispatch(startSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(startError(forgetError))
    }
};
export const inquirySubmit = (orgId, id, data, action, callback) => async (dispatch, getState) => {
    try {
        const response = await inquirySubmitAPI(orgId, id, data, action)
        if (response) {
            dispatch(startSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(startError(forgetError))
    }
};

export const inquiryGet = (orgId, id, callback) => async (dispatch, getState) => {
    try {
        const response = await inquiryGetAPI(orgId, id)
        if (response) {
            dispatch(startSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(startError(forgetError))
    }
};
export const inquiryGetMedia = (orgId, id, callback) => async (dispatch, getState) => {
    try {
        const response = await inquiryGetMediaAPI(orgId, id)
        if (response) {
            dispatch(getMediaSuccess(response))
        }
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(getMediaError(forgetError))
    }
};
export const inquiryDeleteMedia = (orgId, id, mediaId, callback) => async (dispatch, getState) => {
    try {
        const response = await inquiryDeleteMediaAPI(orgId, id, mediaId)
        if (callback) callback(response)
        return response;
    } catch (forgetError) {
        dispatch(getMediaError(forgetError))
    }
};

export const inquiryCreateMedia = (orgId, id, description, file, callback) => async (dispatch) => {
    try {
        let response = await inquiryCreateMediaAPI(orgId, id, description, file, false)
        if (callback) callback(response)
    } catch (forgetError) {
        dispatch(getMediaError(forgetError))
    }
}

export default registerSlice.reducer;
